import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { renderField } from '../../util/arraysUtil';
import {
    validarApenasNumero,
    maxValueMonetario,
    renderFieldHora,
    renderFieldMonetarioLabelEncima,
    renderFieldNumber,
    renderFieldSelect,
    required,
    requiredSelect,
    tamanhoHoraMinuto,
    validateMinutos,
    validateHora
} from '../../util/inputs';
import selecionarVeiculoItinerario from '../../actions/itinerario/selecionarVeiculoItinerario';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import InputMask from 'react-input-mask';
import { modalTransporte } from '../../util/constantsUtil';
import { showAlertMsg } from '../../util/messagesUtil';

export class FormCadastroEmissaoCteOS extends Component {

    validarCampoValorValorServico(e) {
        if (e.target.value == 'R$0,00') {
            showAlertMsg('È necessário informar o valor do serviço');
        }
    }

    render() {
        return (
            <div>
                <div className="form-row">
                    <div className="col-12 col-sm-3 col-md-3">
                        <Field name="numeroCteOS" type="text" component={renderField}
                            label="Número CT-e OS:"
                            css="form-control" readOnly={true} />
                    </div>

                    <div className="col-12 col-sm-2 col-md-2">
                        <Field name="modelo" type="text" component={renderField}
                            label="Modelo:"
                            css="form-control" readOnly={true} />
                    </div>
                    <div className="col-12 col-sm-1 col-md-1">
                        <Field name="serie" type="text" component={renderField}
                            formatacao="###"
                            label="Serie:"
                            css="form-control" readOnly={true} />
                    </div>
                    <div className="col-12 col-sm-1 col-md-1">
                        <Field name="dv" type="text" component={renderField}
                            label="Dv:"
                            css="form-control" readOnly={true} />
                    </div>
                    <div className="col-12 col-sm-3 col-md-3">
                        <label className='mt-2'>Data Emissão:</label>
                        <DatePicker
                            readOnly={true}
                            className='form-control col-md-12'
                            value={this.props.dataEmissao}
                            locale="pt-BR"
                            minDate={new Date()}
                            selected={this.props.dataEmissao && moment(this.props.dataEmissao)
                                .toDate()}
                            onChange={date => this.props.selecionarDataEmissao(date)}
                            dateFormat="dd/MM/yyyy"
                            disabled={true}
                            customInput={<InputMask mask="99/99/9999" />}
                        />
                    </div>
                    <div className="col-12 col-sm-2 col-md-2">
                        <Field name="horaEmissao" type="texto" component={renderField}
                            label='Hora Emissão:'
                            css="form-control" readOnly={true} />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name='modal'
                            options={modalTransporte.map(elemento => ({
                                descricao: elemento.valor,
                                nome: elemento.chave
                            }))}
                            onChange={(e) => this.props.handleModalTransporte(e)}
                            component={renderFieldSelect}
                            label='Modal:'
                            placeholder='Selecione...'
                            disabled={this.props.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento()}
                        />
                    </div>
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name='tipoServico'
                            options={this.props.tiposServicos.map(elemento => ({
                                descricao: elemento.valor,
                                nome: elemento.chave
                            }))}
                            onChange={(e) => this.props.handleSelecionarTipoServico(e)}
                            component={renderFieldSelect}
                            label='Tipo Serviço:'
                            placeholder='Selecione...' validate={requiredSelect}
                            disabled={this.props.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento()}
                        />
                    </div>
                </div>
                <div className="form-row">
                    {this.props.exibirCampoBusca()}
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-12 col-md-12">
                        <Field name='tomador'
                            options={this.props.tomadores.map(it => ({
                                descricao: it.valor,
                                nome: it.chave
                            }))}
                            component={renderFieldSelect}
                            label="Tomador:"
                            placeholder='Selecione...' validate={requiredSelect}
                            onChange={(e) => this.props.handleSelecionarTomador(e)} 
                            disabled={this.props.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento()}
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-12 col-md-12">
                        <Field name='naturezaOperacao'
                            options={this.props.naturezasOperacoes.map(it => ({
                                descricao: it.valor,
                                nome: it.chave
                            }))}
                            component={renderFieldSelect}
                            label="Natureza da Operação:"
                            placeholder='Selecione...' validate={requiredSelect}
                            onChange={(e) => this.props.handleSelecionarNaturezaOperacao(e)}
                            disabled={this.props.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento()}
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-8 col-md-8">
                        <Field name="descricaoServico" type="text" validate={[required]} component={renderField}
                            label="Descrição Serviço"
                            css="form-control" 
                            max={30}
                            readOnly={this.props.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento()} />
                    </div>
                    <div className="col-12 col-sm-4 col-md-4">
                        <Field name="quantidadeCarga" type="text" validate={[required]} component={renderFieldNumber}
                            label="Quantidade Carga:"
                            css="form-control" readOnly={this.props.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento()} />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name='responsavelSeguro'
                            options={this.props.responsaveisSeguros.map(elemento => ({
                                descricao: elemento.valor,
                                nome: elemento.chave
                            }))}
                            placeholder='Selecione...' validate={requiredSelect}
                            onChange={(e) => this.props.handleSelecionarResponsavelSeguro(e)}
                            component={renderFieldSelect}
                            label='Responsável Seguro:'
                            disabled={this.props.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento()}
                        />
                    </div>
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name='seguro'
                            options={this.props.seguros.map(elemento => ({
                                descricao: elemento.valor,
                                nome: elemento.chave
                            }))}
                            onChange={(e) => this.props.handleSelecionarSeguro(e)}
                            component={renderFieldSelect}
                            label='Seguro:'
                            placeholder='Selecione...'
                            disabled={this.props.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento()}
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="tabelaFrete" type="text" component={renderField}
                            label="Tabela Frete:"
                            css="form-control" readOnly={this.props.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento()} />
                    </div>
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="valorServico" validate={[required, maxValueMonetario]}
                            component={renderFieldMonetarioLabelEncima}
                            label="Valor Servico:"
                            onBlur={(e) => this.validarCampoValorValorServico(e)}
                            readOnly={this.props.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento()}
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="termoAutorizacaoFretamento" type="text" validate={[required, validarApenasNumero]} component={renderField}
                            label="Termo de Autorização de Fretamento:"
                            css="form-control" 
                            readOnly={this.props.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento()}
                        />
                    </div>
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="numeroRegistroEstadual" type="text" component={renderField}
                            label="Numero Registro Estadual:"
                            css="form-control" readOnly={true} disabled={this.props.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento()} />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-3 col-md-3">
                        <Field name='tipoFretamento'
                            options={this.props.tiposFretamentos.map(elemento => ({
                                descricao: elemento.valor,
                                nome: elemento.chave
                            }))}
                            placeholder='Selecione...'
                            onChange={(e) => this.props.handleSelecionarTipoFretamento(e)}
                            component={renderFieldSelect}
                            label='Tipo Fretamento:' validate={requiredSelect}
                            disabled={this.props.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento()}
                        />
                    </div>
                    <div className="col-12 col-sm-3 col-md-3">
                        <label className='mt-2'>Data da Viagem:</label>
                        <DatePicker
                            className='form-control col-md-12'
                            value={this.props.dataViagem}
                            locale="pt-BR"
                            minDate={new Date()}
                            selected={this.props.dataViagem && moment(this.props.dataViagem)
                                .toDate()}
                            onChange={date => this.props.selecionarDataViagem(date)}
                            dateFormat="dd/MM/yyyy"
                            disabled={this.props.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento()}
                            customInput={<InputMask mask="99/99/9999" />}
                        />
                    </div>
                    <div className="col-12 col-sm-2 col-md-2">
                        <Field name="horaViagem" type="texto" component={renderFieldHora}
                            label='Hora Viagem:'
                            css="form-control" readOnly={this.props.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento()}
                            validate={[validateMinutos, validateHora, tamanhoHoraMinuto]} />
                    </div>
                    <div className="col-12 col-sm-4 col-md-4">
                        <Field name='veiculo'
                            options={this.props.veiculos.map(elemento => ({
                                descricao: elemento.valor,
                                nome: elemento.chave
                            }))}
                            component={renderFieldSelect}
                            label="Veículo"
                            placeholder='Selecione um veículo'
                            onChange={(e) => this.props.handleSelecionarVeiculo(e)}
                            disabled={this.props.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento()}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        tomadores: state.opcoesFiltrosEmissaoesCteOs.tomadores,
        naturezasOperacoes: state.opcoesFiltrosEmissaoesCteOs.naturezasOperacoes,
        veiculos: state.opcoesFiltrosEmissaoesCteOs.veiculos,
        tiposServicos: state.opcoesFiltrosEmissaoesCteOs.tipoServico,
        responsaveisSeguros: state.opcoesFiltrosEmissaoesCteOs.responsavelSeguro,
        seguros: state.opcoesFiltrosEmissaoesCteOs.seguro,
        tiposFretamentos: state.opcoesFiltrosEmissaoesCteOs.tipoFretamento
    }
}

export default connect(mapStateToProps, {
    selecionarVeiculoItinerario
})(reduxForm({
    form: 'formularioCadastroCteOS'
})(FormCadastroEmissaoCteOS));